export class WarenkorbPosition {
    warenkorb_id: number;
    artikel_id: number;
    artikel: string;
    lieferant_id: number;
    lieferant: string;
    einheit: string;
    einheit_roh: string;
    einheit_alternativ: string;
    gebindegroesse: number;
    menge: number;
    bestellmenge: number;
    vorname: string;
    nachname: string;
    menge_soll: number;
    status_id: number;
    status: string;
    erstellt: Date;
    erstellt_von: number;
    editiert: Date;
    editiert_von: number;
    kommentar: string;
    /** 0 Praxis-Warenkorb, 1 Labor-Bestellungswarenkorb */
    labor: number;
}

export interface WarenkorbPositionApi {
    records: WarenkorbPosition[];
    count: number;
}

export interface GuenstigerWirkstoffArtikel {
    artikel_id: number;
    bezeichnung: string;
    artikel_me: string;
    lieferant: string;
    ek_preis: number;
    preis_einheit: number;
    einheit_basis: string;
    menge: number;
    einheit: string;
    warengruppe: string;
}

export interface GuenstigerWirkstoff {
    wirkstoff: string;
    eigen_ek_preis: number;
    eigen_preis_einheit: number;
    einheit_basis: string;
    alternativ: GuenstigerWirkstoffArtikel | null;
}
